module.exports = __webpack_public_path__ + "img/phone-32.739fd675.svg";